import { render, staticRenderFns } from "./SquatationPrint.vue?vue&type=template&id=0a6f653b"
import script from "./SquatationPrint.vue?vue&type=script&lang=js"
export * from "./SquatationPrint.vue?vue&type=script&lang=js"
import style0 from "./SquatationPrint.vue?vue&type=style&index=0&id=0a6f653b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports